import { cn } from '@/lib/utils'

// The wake behind the arm: twelve wedges, each from the arm at twelve o'clock back
// 120, 110 ... 10 degrees, out to the ring's inner edge (r 8.6). At 5.6% each they
// stack to about 50% at the arm and fade to nothing, with no seams between bands.
const WAKE = [
  'M12 12 L4.552 16.3 A8.6 8.6 0 0 1 12 3.4 Z',
  'M12 12 L3.919 14.941 A8.6 8.6 0 0 1 12 3.4 Z',
  'M12 12 L3.531 13.493 A8.6 8.6 0 0 1 12 3.4 Z',
  'M12 12 L3.4 12 A8.6 8.6 0 0 1 12 3.4 Z',
  'M12 12 L3.531 10.507 A8.6 8.6 0 0 1 12 3.4 Z',
  'M12 12 L3.919 9.059 A8.6 8.6 0 0 1 12 3.4 Z',
  'M12 12 L4.552 7.7 A8.6 8.6 0 0 1 12 3.4 Z',
  'M12 12 L5.412 6.472 A8.6 8.6 0 0 1 12 3.4 Z',
  'M12 12 L6.472 5.412 A8.6 8.6 0 0 1 12 3.4 Z',
  'M12 12 L7.7 4.552 A8.6 8.6 0 0 1 12 3.4 Z',
  'M12 12 L9.059 3.919 A8.6 8.6 0 0 1 12 3.4 Z',
  'M12 12 L10.507 3.531 A8.6 8.6 0 0 1 12 3.4 Z',
]

/** The Queue icon while the radar sweeps: an arm turns with a fading wake, and a
 *  blip lights as the arm passes it, then dims. A 16px icon box (h-4 w-4) like the
 *  menu's other icons. Pass className to resize or recolour it. Styles: .radar-sweep in globals.css. */
export function RadarSweep({ className }: { className?: string }) {
  return (
    <span className={cn('radar-sweep h-4 w-4 text-foreground', className)} aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle className="radar-sweep-ring" cx="12" cy="12" r="9.5" />
        <circle className="radar-sweep-blip" cx="16.83" cy="16.05" r="1.6" fill="currentColor" stroke="none" />
        <g className="radar-sweep-arm">
          <g fill="currentColor" fillOpacity="0.056" stroke="none">
            {WAKE.map((d) => <path key={d} d={d} />)}
          </g>
          <path d="M12 12 V3.5" />
        </g>
      </svg>
    </span>
  )
}
